import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useProjectStore } from '../../../../../Stores/ProjectStore';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { NavigationTab } from '@shared/Interfaces/Navigation/NavigationTab';
import { NavigationTabs } from '@shared/Widgets/Navigation/NavigationTabs/NavigationTabs';
import { ROUTES } from '@configs/AppRoutes';

export const StepNavigationHeader: React.FC = () => {
    const { projectId = '', viewMode = StepsViewModeEnum.PROJECT } = useParams<{
        projectId?: string;
        viewMode?: string;
    }>();
    const location = useLocation();

    if (!projectId && viewMode === StepsViewModeEnum.PROJECT) {
        return null;
    }

    const isStep1or2 =
        location.pathname.includes('/create_new_project/') ||
        location.pathname.includes('/step2/');
    const isStep3 = location.pathname.includes('/step3/');

    let tabs: NavigationTab[] = [];

    if (isStep1or2) {
        tabs = [
            {
                label: 'Dimensions management',
                path:
                    viewMode === StepsViewModeEnum.PROJECT
                        ? ROUTES.STEP1.getPath(
                              StepsViewModeEnum.PROJECT,
                              projectId
                          )
                        : ROUTES.STEP1.getPath(StepsViewModeEnum.PRESENTATION),
            },
            {
                label: 'Products management',
                path:
                    viewMode === StepsViewModeEnum.PROJECT
                        ? ROUTES.STEP2.getPath(
                              StepsViewModeEnum.PROJECT,
                              projectId
                          )
                        : ROUTES.STEP2.getPath(StepsViewModeEnum.PRESENTATION),
            },
        ];
    } else if (isStep3) {
        tabs = [
            {
                label: 'Select products to order',
                path:
                    viewMode === StepsViewModeEnum.PROJECT
                        ? ROUTES.STEP3.getPath(
                              StepsViewModeEnum.PROJECT,
                              projectId
                          )
                        : ROUTES.STEP3.getPath(StepsViewModeEnum.PRESENTATION),
            },
        ];
    }

    return <NavigationTabs tabs={tabs} />;
};
